import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../constants';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';

class LoggedOutComponent extends React.Component {
    showLoginModal = () =>
        this.props.showModal(MODAL_TYPE_LOGIN, { redirectUrl: this.props.urlConnection });

    render() {
        const { i18n, isButton } = this.props;
        return (
            <div className="flex-container-h flex-center-alt">
                {isButton ? (
                    <React.Fragment>
                        <ButtonComponent
                            cssClass="connexion hidden-mobonly isButton"
                            color="main"
                            onClick={this.showLoginModal}
                            text={
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-connexion.svg`}
                                        width="15"
                                        height="15"
                                    />
                                    <span>{i18n.LOG_IN}</span>
                                </React.Fragment>
                            }
                        />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div
                            className="connexion hidden-mobonly isLink"
                            onClick={this.showLoginModal}>
                            <span>{i18n.LOG_IN}</span>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

LoggedOutComponent.propTypes = {
    urlConnection: PropTypes.string,
    i18n: PropTypes.object.isRequired,
    isButton: PropTypes.bool
};

const mapStateToProps = state => {
    return { i18n: state.i18n.feature.header.MEMBER_NAV };
};

const mapDispatchToProps = { showModal };

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedOutComponent.js